<ul>
  @for (breadcrumb of (breadcrumbs$ | async); track breadcrumb; let last = $last; let first = $first) {
    <li class="breadcrumb-item">
      @if (!first) {
        <span> > </span>
      }
      <a [ngClass]="{'latest': last}">{{ breadcrumb.label }}</a>
    </li>
  }
</ul>